import { Typography } from "antd";
const { Title, Text } = Typography;
interface ReviewHeaderProps {
  passFailStatus: string | null;
  reviewerName: string;
  is_attempted: boolean;
  obtained_marks: number;
  total_marks: number;
  passing_percentage: number;
}
export default function ReviewHeader({
  passFailStatus,
  reviewerName,
  is_attempted,
  obtained_marks,
  total_marks,
  passing_percentage,
}: ReviewHeaderProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "20px",
      }}
    >
      <Title level={4} style={{ margin: 0 }}>
        Review Assessment{" "}
        {is_attempted && total_marks && (
          <div>
            <Text italic type="secondary" style={{ color: "#1D322D" }}>
              <span style={{ fontSize: "14px", fontWeight: 500 }}>
                Marks Obtained: {obtained_marks}/{total_marks}
              </span>{" "}
              |{" "}
              <span style={{ fontSize: "14px", fontWeight: 500 }}>
                Passing Percent: {passing_percentage}
              </span>
            </Text>
          </div>
        )}
      </Title>

      {passFailStatus &&
        (passFailStatus === "fail" || passFailStatus === "pass") && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "18px",
              fontWeight: 500,
              gap: "9px",
            }}
          >
            <Text
              style={{
                borderRadius: "4px",
                padding: "5px 25px",
                color: "#fff",
                backgroundColor:
                  passFailStatus === "pass" ? "#52C41A" : "#FF4D4F",
              }}
              type="success"
            >
              {passFailStatus === "pass" ? "Pass" : "Fail"}
            </Text>
            <Text italic type="secondary" style={{ color: "#1D322D" }}>
              Reviewed by: {reviewerName}
            </Text>
          </div>
        )}
    </div>
  );
}
